import React, { useState, useEffect } from 'react';
import './TopBar.css';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SideMenuFornecedor from '../Menu/SideMenuFornecedor';

const TopBarFornecedor = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };

    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className={`top-bar ${isMenuExpanded ? 'menu-expanded' : ''}`}>
        <div className="top-bar-section">
          <IconButton
            onClick={toggleMenu}
            className="menu-button"
            sx={{ 
              color: 'white',
              padding: '4px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            {isOpen ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </div>
        <div className="top-bar-title">G2 Peças</div>
        <div className="top-bar-user">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* Botão de logout pode ser adicionado aqui se necessário */}
          </Box>
        </div>
      </div>
      <SideMenuFornecedor isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default TopBarFornecedor; 